import wx from './wx'
import store from '@/store'
import { AxiosError } from 'axios'
import { showToastFail } from '@/utils/tools'

function getRequestProxyPrefix(url: string): string {
  // 获取接口的代理主体
  const list = url.split('/')
  const proxyPrefix = list.filter((val) => val)[0]
  return proxyPrefix
}
export function getErrorMessage(data: unknown): string {
  const error = data as AxiosError
  const errorObj = error?.response?.data || error
  console.log('errorObj', errorObj)
  const message = errorObj?.message || '请求失败，请稍后再试'
  return message
}
export function commonErrorHandle(data: unknown): void {
  const message = getErrorMessage(data)
  showToastFail(message)
}
function proxyErrorHandle(proxyName: string, error: AxiosError) {
  // 针对不同服务器的代理
  if (proxyName === 'api-account' || proxyName === 'api-member') {
    // 属于账号中心的代理
    commonErrorHandle(error)
  } else {
    const errorObj = error?.response?.data || error
    const errorUnUseDefault = error?.response?.config?.headers?.errorUnUseDefault
    const useErrorDefaultHandle = errorUnUseDefault !== '1'
    if ([4304, 1002, 4303].includes(errorObj.status) && useErrorDefaultHandle) {
      // 已下是原有错误处理逻辑，为让以前的代码正常运行，暂不修改
      // 用户登录有问题，事实上登出也得执行下面的代码，但目前系统无登出的功能，网站关闭也会相当于执行了下面的代码
      if (
        store.getters.isMiniProgram &&
        (errorObj.status === 4304 || errorObj.status === 4303 || errorObj.status === 1002)
      ) {
        wx.relogin()
      }
      store.commit('setUserInfo')
      store.commit('setSelectedDevices')
      store.commit('setFaultBill')
    }
  }
}
export function requestErrorHandle(error: AxiosError): void {
  const config = error.response.config
  console.log('config', config)
  const url = config.url
  const proxyPrefix = getRequestProxyPrefix(url)
  proxyErrorHandle(proxyPrefix, error)
  return
}
